import React, { Component } from 'react';
import './App.css';
import Board from './Board.js';





class App extends React.Component {
  constructor(){
    super();
    this.state = {
      test:false,
    };
  }

  render() {
    return (
      <div className ="container">
      <Board />
      </div>
    );
  }
}


export default App;





// WEBPACK FOOTER //
// ./src/App.js